<template>
  <section class="modal party" v-if="getParty" @click="changeState('party')">

    <div class="modal-block" @click.prevent.stop>
        <div class="party-header">
            <h4 class="party-title" v-if="getPartyUsers">{{ getPartyUsers.length }} участников</h4>
            <div class="party-add" v-if="getChat.can_add || getChat.admin === getUser.id" @click="$store.dispatch('changeState', {element:'invite'})">
                <img src="@/assets/images/icons/icon_plus.svg">
                <p>Пригласить</p>
            </div>
        </div>
        <div class="party-body" v-if="getPartyUsers">
            <router-link :to="'/user/'+ user.id" class="party-user" v-for="user of getPartyUsers" :key="user.id" >
            <div class="party-user__close" @click.prevent.stop="deleteUser(user)" v-if="getUser && getChat && getUser.id === getChat.admin && user.id !== getChat.admin">
                <span></span>
                <span></span>
              </div>
                <div class="party-user__avatar" :style="{ backgroundImage: 'url(' + user.avatar + ')' }"></div>
                <p class="party-user__name">{{ user.firstname + ' ' + user.lastname }}</p>
            </router-link>
        </div>
    </div>
  </section>
</template>
<script>

export default {
  name: "ModalEvent",
  computed: {
      getParty() {
          return this.$store.getters.party
      },
      getPartyUsers() {
          return this.$store.getters.getPartyChat
      },
      getChat() {
          return this.$store.getters.getActiveChat
      },
      getUser() {
          return this.$store.getters.getAuthUser
      }
  },
  methods: {
    changeState (element) {
        this.$store.dispatch('changeState', {element})
    },
    async deleteUser (deleting) {
      let user = {
        id: this.getUser.id,
        firstname: this.getUser.firstname,
        lastname: this.getUser.lastname,
        avatar: this.getUser.avatar
      };
      this.$socket.emit('delete_user', {chat: this.getChat.id, deleting: deleting, user: user})
      this.$store.dispatch('createNotification', {from_id: this.getUser.id, user: deleting.id, type: 'delete_from_chat', chat_id: this.getChat.id} )
    }
  }
};
</script>